import { Vue, newVue } from '@/config/vue'

const init = () => {
  const NewsletterSignup = Vue.component('newsletter-signup', () =>
    import(/* webpackChunkName: "newsletter-signup" */ './NewsletterSignup.vue')
  )
  newVue({
    render: h => h(NewsletterSignup),
    mount: '.js-vue-newsletter-signup',
  })
}
window.On.FooterVueInit = init

On.VueInit({
  init({ isCheckout, isSpa }) {
    if (!isCheckout && !isSpa) init()
  },
})
